import React from 'react';
import { DashboardLayout } from 'src/containers';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { checkShift, openShift } from 'src/redux/action/shifts.action';
import { useDispatch } from 'react-redux';
import { Field, Form, Formik } from 'formik';
import TextField from 'src/components/text-field';
import Button from 'src/components/button';
import { useNavigate } from 'react-router-dom';

const FORM_VALIDATION = Yup.object().shape({
  openingFloat: Yup.number()
    .required('Amount is required')
    .min(0, 'Amount must be greater than or equal to 0'),
});

const ShiftOpen: React.FC = () => {
  const dispatch = useDispatch();
  const [errorMsgPost, setErrorMsgPost] = React.useState('');
  const navigate = useNavigate();
  const { shiftData } = useSelector(({ shiftData }: RootState) => shiftData);
  const auth = useSelector(({ authReducer }: RootState) => authReducer);
  React.useEffect(() => {
    dispatch(checkShift() as any);
  }, [shiftData]);

  const intValues = {
    openingFloat: 0,
    note: '',
  };

  const handleSubmit = async (val: any) => {
    dispatch(openShift(val) as any);
  };
  React.useEffect(() => {
    if (shiftData && auth.role === 'admin') {
      return navigate('/');
    }
    if (shiftData && auth.role !== 'admin') {
      return navigate('/dine-in');
    }
  }, [shiftData]);

  return (
    <>
      <div className="w-full h-full text-black flex flex-col  justify-center gap-4  items-center ">
        <div>
          <div className="text-center font-Outfit font-semibold text-[26px] leading-8">
            Shift Open
          </div>
          <div className="text-center font-Outfit font-normal text-[14px] leading-[21px] text-[#949CC0] mt-1">
            Set an opening float to open shift and make a sale
          </div>
        </div>

        <div>
          {errorMsgPost && (
            <p className="text-warning text-center text-sm font-semibold capitalize">
              {errorMsgPost}
            </p>
          )}
          <Formik
            initialValues={intValues}
            validateOnMount
            validationSchema={FORM_VALIDATION}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, isValid }) => (
              <Form className="mt-5">
                <TextField
                  type="text"
                  label="Opening Float"
                  name="openingFloat"
                  labelClassName="text-[14px] leading-[21px] text-text-black font-normal font-Outfit "
                />

                <div className="mt-1 flex flex-col  ">
                  <label
                    htmlFor="note"
                    className="text-[14px] leading-[21px] text-text-black font-normal font-Outfit "
                  >
                    Note(optional)
                  </label>
                  <Field
                    as="textarea"
                    className="border-[1px] w-[340px] border-light-gray rounded-xl px-1 py-2 focus:border-[1px] focus:border-primary-200 mt-3 focus:shadow-none focus:ring-0 focus:outline-none"
                    rows={4}
                    cols={42}
                    name="note"
                  />
                </div>

                <div className="flex items-center justify-end mt-10">
                  <Button
                    className="w-[340px] flex justify-center"
                    text="Open Shift"
                    variant="primary"
                    isSubmitting={isSubmitting}
                    isValid={isValid}
                    type="submit"
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default ShiftOpen;
